import React from 'react';
import TitleCard from 'components/TitleCard';
import { PanelHeader, PanelTitle, PanelWrapper } from 'components/InspectorPanel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function StatsWrapper(_ref) {
  var _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout,
    title = _ref.title,
    actions = _ref.actions,
    children = _ref.children;
  if (isPanelLayout) {
    return /*#__PURE__*/_jsxs(PanelWrapper, {
      children: [/*#__PURE__*/_jsx(PanelHeader, {
        actions: actions,
        children: /*#__PURE__*/_jsx(PanelTitle, {
          children: title
        })
      }), children]
    });
  }
  return /*#__PURE__*/_jsx(TitleCard, {
    title: title,
    sideContent: actions,
    children: children
  });
}
export default StatsWrapper;